var _rect, _rect2, _path, _path2, _circle, _circle2, _path3, _path4, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMaxCashOut = function SvgMaxCashOut(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.224,
    height: 12.509,
    x: 6.894,
    y: 10,
    fill: "#CAEED2",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 12,
    x: 5.5,
    y: 8.726,
    stroke: "#000",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M5.49 22.51h23.02M5.49 24.26h23.02M5.49 26.013h23.02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M9.04 8.716c.062 1.222-.54 3.667-3.437 3.667M28.623 12.267c-1.223.061-3.668-.541-3.668-3.438M5.49 17.186c1.222-.061 3.667.54 3.667 3.438M25.071 20.624c-.06-1.223.541-3.668 3.439-3.668"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.85,
    cy: 10.713,
    r: 0.13,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14.726,
    r: 3.566,
    fill: "#4E7B57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M2.758 4v3.226M1 5.602h3.516"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.42 15.744c0 .19-.047.372-.14.546-.092.17-.232.31-.418.424a1.41 1.41 0 0 1-.679.188v.485h-.266v-.491c-.36-.032-.65-.15-.873-.352a1.083 1.083 0 0 1-.358-.763h.455a.864.864 0 0 0 .218.497c.133.145.32.234.558.266v-1.679a4.73 4.73 0 0 1-.655-.218 1.055 1.055 0 0 1-.412-.333c-.113-.154-.17-.358-.17-.613 0-.319.111-.581.334-.787.222-.21.523-.324.903-.34v-.51h.266v.516c.336.033.605.142.807.328.202.185.32.418.357.697H17.9a.779.779 0 0 0-.225-.419.825.825 0 0 0-.49-.242v1.618c.262.069.476.142.642.219.17.072.311.185.424.339.113.154.17.362.17.624Zm-2.31-2.06c0 .226.07.397.207.515.141.113.341.208.6.284v-1.557c-.243.012-.439.082-.588.212-.146.13-.219.311-.219.545Zm1.073 2.873c.259-.017.46-.098.6-.243a.772.772 0 0 0 .213-.552c0-.23-.071-.404-.212-.52-.138-.118-.338-.217-.6-.298v1.612Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.761,
    cy: 14.726,
    r: 0.716,
    fill: "#000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.239,
    cy: 14.726,
    r: 0.716,
    fill: "#000"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMaxCashOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Max_Cash_Out.304d04009e8f50cda384ba904b3fbe96.svg";